import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from './AnimatedCheckmark.scss';
import { IconV1Props } from '../../Icon';

const AnimatedCheckmark: React.FC<IconV1Props> = ({ icon }) => {
  return (
    <svg
      className={cn(s.animatedCheckmark, 'svg-icon--animatedCheckmark')}
      id="checkmark"
      data-icon={icon}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
    >
      <circle
        className={cn(s.animatedCheckmarkCircle)}
        cx="26"
        cy="26"
        r="25"
        fill="none"
      />
      <path
        className={cn(s.animatedCheckmarkCheck)}
        fill="none"
        d="M14.1 27.2l7.1 7.2 18.7-18.8"
      />
    </svg>
  );
};

export default AnimatedCheckmark;
